export default function parseQueryString(str) {
  return Object.fromEntries(new URLSearchParams(str));
}
